<template>
  <v-row>
    <v-col cols="12" class="pa-0">
      <v-card flat>
        <v-card-title primary-title>
          <h2>Tankolások</h2>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="py-0">
              <v-row>
                <v-col cols="12" md="2" hidden-xs-only class="pb-0 pt-2">
                  <v-btn :block="true" color="info" @click="$router.go(-1)">
                    Vissza
                  </v-btn>
                </v-col>
                <v-col cols="12" md="2" offset-md="5" class="py-0">
                  <v-btn
                    :block="true"
                    color="primary"
                    :to="`/autok/${$route.params.id}/tankolasok/newTankolas`"
                  >
                    Új Tankolás
                  </v-btn>
                </v-col>
                <v-col cols="12" md="3" class="py-0">
                  <v-text-field
                    v-model="filter"
                    label="Keresés"
                    append-icon="search"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="py-0">
              <v-data-table
                :items="items"
                :headers="headers"
                :loading="isLoading"
                :search="filter"
                :footer-props="{ showFirstLastPage: true }"
              >
                <template v-slot:[`item.atlagfogyasztas`]="{ item }">
                  {{ fogyasztas(item.liter, item.km_ora, item.elozo_km) }}
                  l/100km
                </template>
                <template v-slot:[`item.muveletek`]="{ item }">
                  <v-btn
                    :block="true"
                    :to="`/autok/${item.autoid}/tankolasok/${item.id}`"
                    color="success"
                  >
                    Tankolás Adatlap
                  </v-btn>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col class="d-sm-none">
      <v-btn color="info" fab bottom left fixed @click="$router.go(-1)"
        ><v-icon>arrow_left</v-icon></v-btn
      >
    </v-col>
  </v-row>
</template>

<script>
export default {
  title: "Tankolások",
  data() {
    return {
      isLoading: true,
      filter: this.$store.getters["getTankolas"],
      items: [],
      headers: [
        { text: "Azonosító", value: "id" },
        { text: "Dátum", value: "datum" },
        { text: "Kilóméteróra állása", value: "km_ora" },
        { text: "Dolgozó", value: "dolgozo" },
        { text: "Ár", value: "ar" },
        { text: "Átlagfogyasztás", value: "atlagfogyasztas" },
        { text: "Műveletek", value: "muveletek" }
      ]
    };
  },
  beforeMount() {
    this.getData();
  },
  beforeDestroy() {
    this.saveInfo();
  },
  methods: {
    fogyasztas(liter, km_ora, elozo_km) {
      let fogy = liter / ((km_ora - elozo_km) / 100);
      if (isNaN(fogy)) return 0;
      return fogy.toFixed(2);
    },
    getData() {
      this.items = [];
      this.isLoading = true;
      this.$axios
        .get(`autok/tankolasokid?autoid=${this.$route.params.id}`)
        .then(response => {
          this.items = response.data;
          this.isLoading = false;
        });
    },
    saveInfo() {
      this.$store.dispatch("saveTankolas", this.filter);
    }
  }
};
</script>

<style lang="stylus"></style>
